import * as yup from "yup";

export const yupSchema = yup.object().shape({
  descricao: yup.string().required("Esse campo é obrigatório"),
});

export const initialValues = {
  descricao: "",
};
